"use client";

import { STATE_COLORS, STATE_LABELS, LIFECYCLE_ORDER } from "./theme";

export function StatusChip({ state }: { state: string }) {
    const [bg, fg] = STATE_COLORS[state] || ["#ece9e2", "#7a786f"];
    const label = STATE_LABELS[state] || state;
    return (
        <span
            style={{ background: bg, color: fg }}
            className="inline-block text-[11px] font-bold rounded-md px-2.5 py-1"
        >
            {label}
        </span>
    );
}

export const LIFECYCLE_COLUMNS: { id: string; label: string }[] = LIFECYCLE_ORDER.map((id) => ({
    id,
    label: STATE_LABELS[id],
}));
